import axios from "axios";
import { isValidResponse } from "../utils/utils";
import i18n from "../utils/i18n";
import { loadingStateData } from "./mocks/loadingStateData";
import { getBrandFromURL, getEnvironment, getVaultValues } from "./helperFunctions";

export const getSharedNavData = async (url: string) => {
    const local = window.location.hostname.includes("localhost") ? true : false;
    const vaultValues = await getVaultValues(local);
    const urlBrand = getBrandFromURL();

    if (getEnvironment() <= 1) {
        if (urlBrand === "chevrolet") {
            url = "https://" + vaultValues.accessoriesChevroletPath + url;
        } else if (urlBrand === "buick") {
            url = "https://" + vaultValues.accessoriesBuickPath + url;
        } else if (urlBrand === "cadillac") {
            url = "https://" + vaultValues.accessoriesCadillacPath + url;
        } else if (urlBrand === "gmc") {
            url = "https://" + vaultValues.accessoriesGMCPath + url;
        }
    }

    return axios.get(url).then(async (response) => {
        try {
            if (response.status !== 200 || response.data.errors) {
                console.error(i18n.t("ERROR_RETRIEVING_ESPOT_DATA"));
                return loadingStateData();
            } else {
                if (await isValidResponse(response.data)) {
                    return response.data;
                }
                console.error(i18n.t("ERROR_RETRIEVING_ESPOT_DATA"));
                return loadingStateData();
            }
        } catch {
            console.error(i18n.t("ERROR_RETRIEVING_ESPOT_DATA"));
            return loadingStateData();
        }
    });
};
